import { boostedJackpotStore } from '../../store/boostedJackpotStore';

export const timeHelper = () => {
  const currentDate = new Date();
  const hours = currentDate.getHours().toString().padStart(2, '0');
  const minutes = currentDate.getMinutes().toString().padStart(2, '0');
  const seconds = currentDate.getSeconds().toString().padStart(2, '0');
  return `${hours}:${minutes}:${seconds}`;
};

export const dateHelper = (date) => {
  const currentDate = new Date(date);
  const day = currentDate.getDate().toString().padStart(2, '0');
  const month = (currentDate.getMonth() + 1).toString().padStart(2, '0'); // Month is zero-based, so add 1
  const year = currentDate.getFullYear().toString();
  return `${day}/${month}/${year}`;
};

export const boostedJackpotDateHelper = () => {
  const { boostedJackpotEndTime } = boostedJackpotStore;

  const currentDate = new Date();
  const target = new Date(boostedJackpotEndTime); // Expecting the target date to be in a valid format like 'YYYY-MM-DDTHH:mm:ss'

  const timeDiff = target - currentDate; // Time difference in milliseconds

  if (timeDiff <= 0) {
    return { days: '00', hours: '00', minutes: '00', seconds: '00' }; // Return 00s if the target date has passed
  }

  const days = Math.floor(timeDiff / (1000 * 60 * 60 * 24))
    .toString()
    .padStart(2, '0');
  const hours = Math.floor((timeDiff % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60))
    .toString()
    .padStart(2, '0');
  const minutes = Math.floor((timeDiff % (1000 * 60 * 60)) / (1000 * 60))
    .toString()
    .padStart(2, '0');
  const seconds = Math.floor((timeDiff % (1000 * 60)) / 1000)
    .toString()
    .padStart(2, '0');

  return {
    days,
    hours,
    minutes,
    seconds,
  };
};

export const timeHelperWithMinutesAndSecond = (second) => {
  const minutes = String(Math.floor(second / 60)).padStart(2, '0');
  const seconds = String(Math.ceil(second % 60)).padStart(2, '0');
  return `${minutes}:${seconds}`;
};
